import {
    FETCH_CHECKINLOGS,
    FETCH_GPBYATTDS,
} from '../actions/checkin';


export const initialState = {
    isFetching: true,
    data: null
};

export const checkinlogs = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CHECKINLOGS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CHECKINLOGS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



export const gpbyattds = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_GPBYATTDS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_GPBYATTDS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/checkin.js